import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteVideoTutorialSlice = createSlice({
    name: "DeleteVideoTutorialSlice",
    initialState: {} as IReduxState<any>,
    reducers: {
        deleteVideoTutorial: (state, action) => {
            state.isLoading = true;
        },
        successdeleteVideoTutorial: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failuredeleteVideoTutorial: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearDeleteVideoTutorialResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    failuredeleteVideoTutorial,
    deleteVideoTutorial,
    successdeleteVideoTutorial,
    clearDeleteVideoTutorialResponse,
} = DeleteVideoTutorialSlice.actions;

export default DeleteVideoTutorialSlice.reducer;
